var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChevronDown = function SvgIconChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1139.4 675.45"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m644.4 645 464.4-464.4c40.8-40.8 40.8-108 0-148.8C1068-9 1000.8-9 960 31.8L570 420.6l-390-390c-40.8-40.8-108-40.8-148.8 0C10.8 51 0 78.6 0 105s10.8 54 31.2 74.4l464.4 464.4c40.8 42 108 42 148.8 1.2Z",
    fill: "currentColor"
  })));
};
export default SvgIconChevronDown;